import {Box, Image, Spinner} from "@chakra-ui/react";
import logo from "../../../assets/images/logo.svg";

const Loader = () => {
    return (
        <Box display={'flex'} w={'100vw'} h={'100vh'} bg={'white'} justifyContent={'center'} alignItems={'center'}
             flexDirection={'column'} rowGap={8}>
            <Image src={logo} h={16}/>
            <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='transparent'
                color='#0A4725'
                size='lg'
            />
        </Box>
    )
}

export default Loader;
